<template>
    <div class="gs-billing-detail">
        <div class="gs-billing-detail__card">
          <div class="gs-billing-detail__grid">
            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_affiliate') }}</label>
                <label class="text-sm text-grey-700 mb-2">{{ purchase.affiliate_name &&
                    purchase.affiliate_name.trim() != '' ? purchase.affiliate_name : 'N/A' }}
                </label>
            </div>
            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_affiliate') }}
                    Email</label>
                <label class="text-sm text-grey-700 mb-2">{{
                    purchase.affiliate_email && purchase.affiliate_email.trim() != '' ?
                    purchase.affiliate_email : 'N/A'
                }}</label>
            </div>

            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_username') }}</label>
                <label class="text-sm text-grey-700 mb-2">{{
                    purchase.affiliate_username && purchase.affiliate_username.trim() != '' ?
                    purchase.affiliate_username : 'N/A'
                }}</label>
            </div>
          </div>
        </div>
    </div>
</template>
<style scoped>
.gs-billing-detail__card {
  padding: 20px 24px;
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  background: var(--gs-surface);
  box-shadow: var(--gs-shadow-sm);
}

.gs-billing-detail__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px 20px;
}

.gs-billing-detail__field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 6px;
}

.gs-billing-detail__field label:first-child {
  color: var(--gs-muted-foreground);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
}

.gs-billing-detail__field label:last-child {
  overflow-wrap: anywhere;
  color: var(--gs-foreground);
  font-size: 14px;
  line-height: 1.5;
}

@media (max-width: 720px) {
  .gs-billing-detail__card {
    padding: 16px;
  }

  .gs-billing-detail__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 480px) {
  .gs-billing-detail__grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
<script>
export default {
    props: {
        purchase: {
            required: true
        }
    }
}
</script>
